import { useState, useEffect } from 'react'
import { FiAward, FiClock } from 'react-icons/fi'

import api from '../../utils/api'
import useFlashMessage from '../../hooks/useFlashMessage'

import './Ranking.css'

const PERIODS = [
    { value: 'all', label: 'Geral' },
    { value: 'month', label: 'Mês' },
    { value: 'year', label: 'Ano' },
]

function Ranking() {
    const [period, setPeriod] = useState('all')
    const [ranking, setRanking] = useState(null)
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        setRanking(null)
        api.get('/user/ranking', { params: { period } }).then((response) => {
            setRanking(response.data.ranking)
        }).catch((error) => {
            setFlashMessage(error.response?.data?.message || 'Não foi possível carregar o ranking', 'error')
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period])

    return (
        <div className="ranking">
            <p className="ranking-eyebrow">Classificação</p>
            <h1 className="ranking-title">Ranking</h1>

            <div className="ranking-tabs">
                {PERIODS.map((p) => (
                    <button
                        key={p.value}
                        className={`ranking-tab${period === p.value ? ' active' : ''}`}
                        onClick={() => setPeriod(p.value)}
                    >
                        {p.label}
                    </button>
                ))}
            </div>

            <div className="ranking-list panel">
                {!ranking && <p className="ranking-empty">Carregando ranking...</p>}
                {ranking?.length === 0 && <p className="ranking-empty">Ainda não há jogadores no ranking neste período.</p>}

                {ranking?.map((player, index) => (
                    <div className={`ranking-row${index < 3 ? ' top' : ''}`} key={player._id}>
                        <div className="ranking-row-top">
                            <div className="ranking-row-main">
                                <span className="ranking-position">
                                    {index < 3 ? <FiAward size={18} /> : `#${index + 1}`}
                                </span>
                                <div className="ranking-player">
                                    <span className="ranking-name">{player.name}</span>
                                    <span className="ranking-username">@{player.userName}</span>
                                </div>
                            </div>
                            <div className="ranking-row-stats">
                                <span className="ranking-hours">
                                    <FiClock size={14} />
                                    {player.hoursPlayed ?? 0}h
                                </span>
                                <span className="ranking-points">{player.points ?? 0} pts</span>
                            </div>
                        </div>
                        <span className="ranking-row-extra">
                            {player.totalKills ?? 0} kills · {player.totalDeaths ?? 0} mortes ·{' '}
                            {player.totalVitorias ?? 0}V/{player.totalDerrotas ?? 0}D
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Ranking
